export default {
  namespaced: true,
  state: {
    headerDark: false,
    headerColor: null,
    footerDark: false,
    footerColor: null,

    navigationButton: 'top-left',
    navigationButtonIcon: 'mdi-menu',
    navigationDark: false,
    navigationColor: null,
    navigationRight: false,
    navigationBottom: true,
    navigationDesktop: 'temporary',

    mainDark: false,
    mainColor: null,
    buttonDark: true,
    buttonColor: 'green darken-3',
    buyButtonDark: true,
    buyButtonColor: 'green darken-1',
    headerGradient: true,
    buttonType: 'normal',
    buyButtonType: 'normal',
    buttonElevation: 0,
    buyButtonElevation: 0,
    footerElevation: 3,
    headerElevation: 3,

    productDark: false,
    productColor: null,
    productElevation: 5,
    productRounded: 'normal',
    productTemplate: 'tile',
    dialogDark: false,
    dialogColor: '#fff',

    menuSectionColor: null,
    menuSectionDark: false,
    menuSectionRight: false,

    stickySection: true,
    stickySectionColor: null,
    stickySectionDark: true,
    stickySectionElevation: 0,

    stickyHeader: true,
    stickyHeaderColor: null,
    stickyHeaderDark: false,
    stickyHeaderElevation: 0,
    stickyHeaderHeight: 44,

    fabUp: true,
    fabsElevation: 12,
    fabsColor: null,
    fabsDark: true,
    fabsSize: 'normal',
  },
  mutations: {
    all(state, values) {
      Object.keys(values)
        .forEach((key) => {
          if (typeof state[key] === 'boolean') {
            state[key] = Number(values[key]) > 0;
          } else if (typeof state[key] === 'number') {
            state[key] = Number(values[key]);
          } else if (values[key]) {
            state[key] = values[key];
          }
        });
    },
  },
};
